<template>
  <q-dialog v-model="dialog" persistent class="order-quotation-dialog quotation-confirm-dialog">
    <q-card>
      <q-toolbar class="information">
        <q-avatar>
          <q-icon name="mdi-alert-circle" />
        </q-avatar>
        <q-toolbar-title class="text-weight-bold">お問い合わせ確認</q-toolbar-title>
      </q-toolbar>
      <q-card-section>
        <span style="font-size: 16px">注意事項</span>
        <ul class="dialog-textarea">
          <li>お問い合わせ内容は確定メールにてご確認ください</li>
        </ul>
        <p class="q-mb-sm" style="margin-left: 21px">
          ※法規制化学物質チェックを行うので処理に時間がかかる可能性があります。
        </p>
      </q-card-section>
      <q-card-actions align="center" class="btn-area q-gutter-md">
        <q-btn color="primary" label="問い合わせ依頼を確定する" style="width: 200px" @click="ok" />
        <q-btn
          outline
          label="キャンセル"
          style="color: var(--q-delete); width: 180px"
          @click="cancel"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  // ダイアログを表示するかどうか
  display: boolean;
}

const props = defineProps<Props>();
const dialog = computed(() => props.display);

const emit = defineEmits<{
  (event: 'ok'): void;
  (event: 'cancel'): void;
}>();

const ok = () => {
  emit('ok');
};

const cancel = () => {
  emit('cancel');
};
</script>
<style scoped>
.quotation-confirm-dialog .q-card {
  min-width: 400px;
  padding: 15px 30px;
}
.quotation-confirm-dialog .q-toolbar .q-avatar {
  font-size: 36px;
}

.quotation-confirm-dialog .q-toolbar.information .q-icon {
  color: var(--q-info);
  font-size: 34px;
}

.quotation-confirm-dialog .q-toolbar .q-toolbar__title {
  font-size: 22px;
  padding-top: 4px;
  line-height: 36px;
  padding-left: 14px;
}
</style>
